import { PhoneNumber } from "../types/phoneNumber"
import { StringFormatter } from "./stringFormatter"

/**
 *  A formatter for the phone number to be formatted in national format.
 *  This format might differ from nation to nation and there isn't really
 *  a registry of formats per country/culture. Internally, we rely on the
 *  awesome-phonenumber library to get the correct format.
 *
 *  @example
 *  Dutch format: `06 12345678`
 *
 *  @see https://en.wikipedia.org/wiki/National_conventions_for_writing_telephone_numbers
 *  @see https://github.com/catamphetamine/libphonenumber-js
 */
export class PhoneNumberNationalFormatter extends StringFormatter<PhoneNumber> {
  protected convert(input: PhoneNumber): string {
    return input.nationalNotation
  }
}
